
import { defineComponent } from 'vue'

// paper information
interface PaperInfo {
  type: string,
  title: string,
  url?: string,
  note?: string
}

export default defineComponent({
  data () {
    return {
      theses: [
        {
          type: 'PhD thesis',
          title: 'Modern classification theory of superconducting gap nodes',
          url: 'theses/phd_thesis.pdf',
          note: '(<a href="https://doi.org/10.14989/doctor.k22236" target="_blank">KURENAI: Kyoto University Research Information Repository</a>)'
        },
        {
          type: 'Master thesis',
          title: '磁気多極子秩序と共存する超伝導の研究 (in Japanese)',
          url: 'theses/ms_thesis.pdf'
        }
      ] as PaperInfo[]
    }
  }
})
